import { Checkbox as MuiCheckbox, TextField } from "@mui/material";
import styled from "styled-components/macro";

export const CfcStepSelectContent = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CfcSelectIntro = styled.header`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 8px;
`;

export const CfcIndicationBlock = styled.article`
  font-size: 16px;
  line-height: 24px;
  font-family: light;
  color: ${({ theme }) => theme.greyMedium};
`;

export const CfcIndicationLabel = styled.span`
  margin: 0;
  font-family: bold;
`;

export const CfcEligibleLead = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-family: light;
  color: ${({ theme }) => theme.greyMedium};
`;

export const CfcConditionList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding: 0 0 16px 8px;
  list-style: none;
  border-bottom: 1px solid ${({ theme }) => theme.neutral100};
`;

export const CfcConditionItem = styled.li`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;

  .MuiCheckbox-root {
    padding: 0;
  }
`;

export const CfcConditionLabel = styled.label`
  font-size: 16px;
  line-height: 24px;
  font-family: bold;
  color: ${({ theme }) => theme.greyDark};
  cursor: pointer;
`;

export const CfcIcd10Section = styled.fieldset`
  margin: 0;
  border: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 16px 16px 8px;
  border-bottom: 1px solid ${({ theme }) => theme.neutral100};
`;

export const CfcSubsectionHeader = styled.legend`
  padding: 0;
  font-size: 20px;
  line-height: 28px;
  font-family: bold;
  color: ${({ theme }) => theme.greyDark};
`;

export const CfcSubsectionDescription = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-family: light;
  color: ${({ theme }) => theme.greyMedium};
`;

export const CfcIcd10Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  .MuiCheckbox-root {
    padding: 0;
  }
`;

export const CfcIcd10Label = styled.label`
  width: 313px;
  font-size: 16px;
  line-height: 16px;
  font-family: light;
  color: ${({ theme }) => theme.greyDark};
  cursor: pointer;

  @media (max-width: 800px) {
    width: auto;
  }
`;

export const CfcIcd10Code = styled.span`
  margin-left: 28px;
  font-size: 16px;
  line-height: 24px;
  font-family: light;
  color: ${({ theme }) => theme.greyMedium};

  @media (max-width: 800px) {
    margin-left: 0;
  }
`;

export const CfcIcd10OtherLabel = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-family: light;
  color: ${({ theme }) => theme.blueDark};
  margin-left: 36px;
`;

export const CfcIcd10OtherInput = styled(TextField)`
  && {
    margin-left: 36px;
    max-width: calc(100% - 36px);
    width: 429px;

    .MuiInput-input {
      font-family: light;
      font-size: 16px;
      line-height: 24px;
      color: ${({ theme }) => theme.black};
      padding: 0 0 8px;
    }
    .MuiInput-root:before {
      border-bottom: 1px solid ${({ theme }) => theme.greyLight};
    }
    .MuiInput-root:hover:not(.Mui-disabled):before {
      border-bottom: 1px solid ${({ theme }) => theme.greyMedium};
    }
    .MuiInput-root:after {
      border-bottom: 1px solid ${({ theme }) => theme.redMedium};
    }
  }
`;

export const CfcPhlebotomyRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 16px 16px 8px;
  border-bottom: 1px solid ${({ theme }) => theme.neutral100};

  .MuiCheckbox-root {
    padding: 0;
  }
`;

export const CfcPhlebotomyCopy = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CfcPhlebotomyTitle = styled.label`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-family: bold;
  color: ${({ theme }) => theme.blueDark};
  cursor: pointer;
`;

export const CfcPhlebotomyDescription = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-family: light;
  color: ${({ theme }) => theme.greyMedium};
`;

export const CfcCheckbox = styled(MuiCheckbox)`
  && {
    color: ${({ theme }) => theme.greyLight};
    &.Mui-checked {
      color: ${({ theme }) => theme.redMedium};
    }
  }
`;

export const CfcSectionTitle = styled.div`
  font-size: 18px;
  line-height: 28px;
  font-family: light;
  color: ${({ theme }) => theme.greyMedium};
`;
